/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Invited_DescInputs */



/**
* | output |
* | --- |
* | "The member was invited to the organisation and received an invitation email." |
*
* @param {Audit_Details_Member_Invited_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_invited_desc = /** @type {((inputs?: Audit_Details_Member_Invited_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Invited_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Mitglied wurde in die Organisation eingeladen und hat eine Einladungs-E-Mail erhalten.")
	return /** @type {LocalizedString} */ ("The member was invited to the organisation and received an invitation email.")
});